





















































import { Component, Prop, Vue } from "vue-property-decorator";
import { StaffSurveyFormResponse } from "@/api";
import FiveStarForm from "@/components/five_star/FiveStarForm.vue";
import SurveyForm from "@/views/staff_survey/form/Form.vue";

@Component({
  components: {
    SurveyForm,
    FiveStarForm,
  },
})
export default class StartStaffSurvey extends Vue {
  @Prop() readonly dispatchType!: string;
  dialog = false;
  callType = this.dispatchType;
  surveyDialog = false;
  counter = 0;

  async created() {
    this.callType = this.dispatchType;
    await this.$store.dispatch(
      "staffSurvey/getActiveStaffSurveyForm",
      this.dispatchType,
    );
  }

  get activeForm(): StaffSurveyFormResponse | null {
    const form =
      (this.$store.getters[
        "staffSurvey/activeForm"
      ] as StaffSurveyFormResponse) || null;
    return form;
  }

  recognize() {
    this.surveyDialog = !this.surveyDialog;
    this.dialog = !this.dialog;
  }

  startSurvey() {
    this.counter++;
    this.surveyDialog = !this.surveyDialog;
  }

  complete() {
    this.$emit("complete", this.callType);
  }
}
